<template>
    <div>
        <ListPage ref="listPage" :query="query" :total="total" v-loading="loading" :data="tableData"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" @search="handleSearch"
            @reset="resetQuery" @selection-change="handleSelectionChange">
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="请输入敏感词" clearable
                        @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="状态" prop="search_status">
                    <el-select v-model="query.search_status" placeholder="请选择状态">
                        <el-option label="启用" value="1" />
                        <el-option label="禁用" value="2" />
                    </el-select>
                </el-form-item>
            </template>
            <template slot="btns"
                v-if="permission('cpgl_mgclb_xzmb') || permission('cpgl_mgclb_dr') || permission('cpgl_mgclb_dc') || permission('cpgl_mgclb_xz')">
                <el-button v-if="permission('cpgl_mgclb_xzmb')" size="mini" type="primary" @click="handleDownload"> 下载模板
                </el-button>
                <el-upload style="margin: 0 10px" v-if="permission('cpgl_mgclb_dr')" action="" :show-file-list="false"
                    :before-upload="beforeUpload">
                    <el-button size="small" type="primary">导入</el-button>
                </el-upload>
                <el-button v-if="permission('cpgl_mgclb_dc')" size="mini" type="primary" @click="handleExport"> 导出
                </el-button>
                <el-button v-if="permission('cpgl_mgclb_xz')" size="mini" type="primary" @click="handleAdd"> 新增
                </el-button>
            </template>
            <template slot="columns">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column label="序号" align="center" type="index" width="100" />
                <el-table-column label="敏感词" align="center" prop="name" />
                <el-table-column label="被触发次数" align="center" prop="triggers_number" />
                <el-table-column label="创建人" align="center" prop="admin.name" />
                <el-table-column label="状态" align="center" width="100">
                    <template slot-scope="{ row }">
                        {{ row.status == 1 ? "启用" : "禁用" }}
                    </template>
                </el-table-column>
                <el-table-column label="最后修改时间" align="center" prop="update_time" />
                <el-table-column label="操作" align="center" width="140">
                    <template slot-scope="{ row }">
                        <el-button v-if="permission(row.status == 1 ? 'cpgl_mgclb_jy' : 'cpgl_mgclb_qy')" size="mini"
                            type="text" @click="handleUpdate(row)">
                            {{ row.status == 1 ? "禁用" : "启用" }}
                        </el-button>
                        <el-button v-if="permission('cpgl_mgclb_bj')" size="mini" type="text" @click="handleEdit(row)">
                            编辑 </el-button>
                        <el-button v-if="permission('cpgl_mgclb_sc')" size="mini" type="text" @click="handleDel(row)">
                            删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <FormVue ref="form" @update="search"></FormVue>
    </div>
</template>

<script>
import { list, del, edit, download, _import } from "@/api/product/word";
import listMixin from "@/mixins/list";
import FormVue from "./form.vue";
import { downloadFileByUrl } from "@/jslibs/utils";
import utils from "@/jslibs/utils";

export default {
    components: { FormVue },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
                search_status: "",
            },
            module: "敏感词",
            pick: true,
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        handleDownload() {
            download().then((res) => {
                const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const filename = "敏感词模板.xlsx";
                utils.downloadBlobFile(blob, filename);
            });
        },
        beforeUpload(file) {
            _import({ file }).then(({ code, error }) => {
                if (code === 200) {
                    this.$message.success("导入成功");
                    this.handleSearch();
                } else {
                    this.$message.error(error.message);
                }
            });
            return false;
        },
        async handleExport() {
            const filename = "敏感词列表.xlsx";
            const { search_keyword, search_status } = this.query;
            const uuids = this.picks.map(x => x.uuid).join();
            downloadFileByUrl(
                process.env.VUE_APP_BASE_URL + `/v1/cms/SensitiveWord?export=1&search_keyword=${search_keyword}&search_status=${search_status}&uuids=${uuids}`,
                filename
            );
        },
        handleAdd() {
            this.$refs.form.open();
        },
        handleUpdate(row) {
            edit({ uuid: row.uuid, name: row.name, status: row.status == 1 ? "2" : "1" }).then(({ code, error }) => {
                if (code == 200) {
                    let msg = row.status == 1 ? "禁用成功" : "启用成功";
                    this.$message.success(msg);
                    this.search();
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleEdit(row) {
            this.$refs.form.open(row);
        },
    },
};
</script>
